import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    linkEmailRes: [],
    verifyLinkRes: [],
    resendverify: [],
    error: "",
}

// RESEND_VERIFY

const linkEmailSlice = createSlice({
    name: 'linkEmail',
    initialState,
    reducers: {
        linkemail: (state, action) => {
            state.linkEmailRes = action.payload
        },
        verify: (state, action) => {
            state.verifyLinkRes = action.payload
        },
        reverify: (state, action) => {

            state.resendverify = action.payload

        }
    }
})

export const { linkemail, verify, reverify } = linkEmailSlice.actions;
export default linkEmailSlice.reducer;


export const linkEmail = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.POST_LINK_MAIL}`, data);
            callback(response)
            dispatch(linkemail(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    };

export const verifyLinkEmail = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.VERIFY_LINK_EMAIL}/${data}`);
            callback(response)
            dispatch(verify(response.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const reverifymail = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.RESEND_VERIFY}`, data);
            callback(response)
            dispatch(reverify(response.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }